module.exports = __webpack_public_path__ + "media/bootstrap-icons/filter-right-c3387271.svg";